const Integrations = {
  amplitude: {
    appName: 'Amplitude',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/amplitude_logo.png'
  },
  jira: {
    appName: 'Jira',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/jira_logo.png'
  },
  adobeExpress: {
    appName: 'Adobe Express',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/adobe_express_logo.png'
  },
  aircall: {
    appName: 'Aircall',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/aircall_logo.png'
  },
  linkedIn: {
    appName: 'LinkedIn',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/linked_in_logo.png'
  },
  microsoftTeams: {
    appName: 'Microsoft Teams',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/microsoft_teams_logo.png'
  },
  salesforce: {
    appName: 'Salesforce',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/salesforce_logo.png'
  },
  zohoCRM: {
    appName: 'Zoho CRM',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/zoho_crm_logo.png'
  },
  pipedrive: {
    appName: 'Pipedrive',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/pipedrive_logo.png'
  },
  microsoftDynamics365: {
    appName: 'Microsoft Dynamics 365',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/dynamics_logo.png'
  },
  clioManage: {
    appName: 'Clio Manage',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/clio_logo.png'
  },
  copper: {
    appName: 'Copper',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/copper_logo.png'
  },
  zoom: {
    appName: 'Zoom',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/zoom_logo.png'
  },
  zapier: {
    appName: 'Zapier',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/zapier_logo.png'
  },
  zendesk: {
    appName: 'Zendesk',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/zendesk_logo.png'
  },
  mailchimp: {
    appName: 'Mailchimp',
    logo: 'https://www.hubspot.com/hubfs/pricing_page/integrations/mailchimp_logo.png'
  }
};
export const getPublicIntegrations = productGroup => {
  switch (productGroup) {
    case 'SMART_CRM':
      {
        return [Integrations.microsoftTeams, Integrations.zoom, Integrations.zapier, Integrations.zendesk, Integrations.mailchimp];
      }
    default:
      {
        return [Integrations.amplitude, Integrations.jira, Integrations.adobeExpress, Integrations.aircall, Integrations.linkedIn, Integrations.microsoftTeams];
      }
  }
};